import { Code2, Heart } from "lucide-react";

export default function Footer() {
  return (
    <footer className="border-t border-white/10 px-5 py-8 sm:px-8 lg:px-10">
      <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-4 text-center text-sm text-slate-400 sm:flex-row sm:text-left">
        <p>© 2026 Төлепберген Нурлан. Built with React & Tailwind CSS.</p>
        <div className="flex items-center gap-3">
          <Code2 className="animate-pulse text-cyan-200" size={18} />
          <span className="text-slate-500">Internship-ready portfolio</span>
          <Heart className="text-purple-300" size={17} />
        </div>
      </div>
    </footer>
  );
}
